import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

enum PanelStatusEnum {
  Complete = 'complete',
  Incomplete = 'incomplete',
  NotStarted = 'not_started',
}

type PanelStatus = 'not_started' | 'incomplete' | 'complete';

@Component({
  selector: 'section-panel',
  templateUrl: './section-panel.component.html',
  styleUrls: ['./section-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SectionPanelComponent {
  panelStatusEnum = PanelStatusEnum;

  @Input() panelStatus: PanelStatus = PanelStatusEnum.NotStarted;
  @Input() panelNumber = 1;
  @Input() panelHeader!: string;
  @Input() panelDescription?: string;
  @Input() isExpanded? = false;
  @Input() applyDefaultPadding? = true;
  @Output() panelClosed = new EventEmitter<boolean>();
  @Output() panelOpened = new EventEmitter<boolean>();
}
